import http from '@utils/http';

// 一键回滚
export function oneKeyRollBack() {
  return http.post('/api/finance/channelRouter/oneKeyRollBack', {});
}

// 一键切换原生
export function oneKeySwitch() {
  return http.post('/api/finance/channelRouter/oneKeySwitch', {});
}
